import { render, staticRenderFns } from "./ImgChanger.vue?vue&type=template&id=ed2c5926"
import script from "./ImgChanger.vue?vue&type=script&lang=js"
export * from "./ImgChanger.vue?vue&type=script&lang=js"
import style0 from "./ImgChanger.vue?vue&type=style&index=0&id=ed2c5926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports